import ResourceLoaderProto from "../../core/core3-depricated/app/resource-loader-proto"
import WorkSchedule from "../../core/gd/manager/work-schedule/work-schedule"
import GlobalFields from "../../core/gd/fields/fields"

const { when } = require('simply-deferred')
import {ViewType} from "../../core/gd/const/views/view-type"
import ApiSharedViewSession from "../../../app/shared-view/gd/api/session"
import ApiSharedViewApp from "../../../app/shared-view/gd/api/shared-view-app"
import Modules from "../../core/modules/modules"


const projectListAppLoaderFunction = () => import(/* webpackChunkName: "task-list" */ './list/project-list/project-app')
const customViewListAppLoaderFunction = () => import(/* webpackChunkName: "task-list" */ './list/custom-list/custom-view-app')

const projectTableAppLoaderFunction = () => import(/* webpackChunkName: "task-table" */ './table/project-table/project-app')
// @ts-ignore
const portfolioOldTableAppLoaderFunction = () => import(/* webpackChunkName: "task-table" */ './table/portfolio-old/portfolio-app')
const customViewTableAppLoaderFunction = () => import(/* webpackChunkName: "task-table" */ './table/custom-table/custom-view-app')
// @ts-ignore
const portfolioSummaryAppLoaderFunction = () => import(/* webpackChunkName: "task-table" */ './table/portfolio-summary/portfolio-summary-app')
const portfolioTableAppLoaderFunction = () => import(/* webpackChunkName: "task-table" */ './table/portfolio/portfolio-app')

const projectBoardAppLoaderFunction = () => import(/* webpackChunkName: "task-board" */ './board/project-board/project-app')
const customViewBoardAppLoaderFunction = () => import(/* webpackChunkName: "task-board" */ './board/custom-board/custom-view-app')

// @ts-ignore
const projectCalendarAppLoaderFunction = () => import(/* webpackChunkName: "calendar" */ './calendar/project-calendar/project-app')
// @ts-ignore
const customViewCalendarAppLoaderFunction = () => import(/* webpackChunkName: "calendar" */ './calendar/custom-calendar/custom-view-app')

const projectGanttAppLoaderFunction = () => import(/* webpackChunkName: "gantt" */ './gantt/project-gantt/project-app')
const customViewGanttAppLoaderFunction = () => import(/* webpackChunkName: "gantt" */ './gantt/custom-gantt/custom-view-app')

const projectWorkloadAppLoaderFunction = () => import(/* webpackChunkName: "workload" */ './workload/project-workload/project-app')
const customViewWorkloadAppLoaderFunction = () => import(/* webpackChunkName: "workload" */ './workload/custom-workload/custom-view-app')

// @ts-ignore
const projectActivityStreamAppLoaderFunction = () => import(/* webpackChunkName: "activity-stream" */ './activity-stream/project-activity/project-app')
// @ts-ignore
const customViewActivityStreamAppLoaderFunction = () => import(/* webpackChunkName: "activity-stream" */ './activity-stream/custom-activity/custom-view-app')

// @ts-ignore
const customViewWhatIsDoneAppLoaderFunction = () => import(/* webpackChunkName: "what-is-done" */ './what-is-done/app')
// @ts-ignore
const customViewActionRequiredAppLoaderFunction = () => import(/* webpackChunkName: "action-required" */ './action-required/app')

// @ts-ignore
const projectDocsAppLoaderFunction = () => import(/* webpackChunkName: "docs" */ './documents/app')

// @ts-ignore
const requestFormAppLoaderFunction = () => import(/* webpackChunkName: "request-form" */ './request-form/index')

const projectDashboardAppLoaderFunction = () => import(/* webpackChunkName: "dashboard" */ './dashboard/project-dashboard/project-app')
const customDashboardAppLoaderFunction = () => import(/* webpackChunkName: "dashboard" */ './dashboard/custom-dashboard/custom-view-app')

const projectPageAppLoaderFunction = () => import(/* webpackChunkName: "page" */ './page/app')
const projectTodosAppLoaderFunction = () => import(/* webpackChunkName: "page" */ './todos/project-todos/project-app')

const unknownAppLoaderFunction = () => import(/* webpackChunkName: "utility" */ './unknown/app')
const notFoundAppLoaderFunction = () => import(/* webpackChunkName: "utility" */ './not-found/app')

// const debug = "SharedViewAppLoader"
const debug = false

export default class SharedViewAppLoader extends ResourceLoaderProto {

    constructor() {
        super()

        debug && console.log(debug, "Constructor()")

        this.domElementId = 'ui-content-center'
    }

    load(appParams: any, showLoading = true) {
        (gd.api.Session as unknown as ApiSharedViewSession).setPublicKey(appParams.publicKey)

        const sharedViewRequest = ApiSharedViewApp.getSharedViewNew(appParams.publicKey)

        sharedViewRequest.done((response:any)=>{
            debug && console.log(debug, 'load() getSharedView response=', response)


            const sessionData = response.session
            const sharedViewData    = response.sharedView


            // gd.setCompany(gd.session.companies.models[0].id)
            gd.setCompany(sharedViewData.companyId)

            // now when 100% that companyId is good process session
            debug && console.log(debug, 'load() process session', sessionData)
            if (sessionData) {
                gd.session.processEvents(sessionData);
            }
            debug && console.log(debug, 'load() process session - Done')
            // end


            gd.workSchedule = new WorkSchedule() // created here because we need companies in session
            gd.fields       = new GlobalFields() // created here because we need company and other session data (like priorities) initiated
            gd.modules      = new Modules(gd.company.settings._modulesConfig)

            this.loadResources(response.sharedView.type, response)

        })


        sharedViewRequest.fail((error:any)=>{
            if (error.code === 403 || error.code === 404) {
                gd.growl.removeAll()
            }

            this.renderNotFoundLoading()
        })

        debug && console.log(debug, 'load() - done')



        // when(gd.api.SharedViewApp.getSharedView(appParams.publicKey)).done((response: any)=>{
        //
        //     debug && console.log(debug, 'load getSharedView', response)
        //
        //     gd.setCompany(gd.session.companies.models[0].id)
        //     gd.workSchedule = new WorkSchedule() // created here because we need companies in session
        //     gd.fields       = new GlobalFields() // created here because we need company and other session data (like priorities) initiated
        //
        //     this.loadResources(response.sharedView.type, response)
        // }).fail((error: any)=>{
        //     if (error.code === 403 || error.code === 404) {
        //         gd.growl.removeAll()
        //     }
        //
        //     this.renderNotFoundLoading()
        // })
        //
        // if (showLoading) this.renderLoading()

        return this.resourceLoader
    }

    loadResources(viewType: ViewType, apiResponse: any) {
        debug && console.log(debug, 'loadResources', viewType, apiResponse)

        when(this.resources(viewType)).then(()=>{
            this.resourceLoader.resolve(this.App, apiResponse)
        }).fail(()=>{
            this.renderErrorLoading()
        })
    }

    resources(viewType?: ViewType) {
        debug && console.log(debug, 'resources', viewType)

        let res: string[] = []

        // CSS
        let css = ['shared-view-container'], viewCss: any[] = []

        switch (viewType) {
            case ViewType.PROJECT_LIST                  :
            case ViewType.CUSTOM_VIEW_TASKS_LIST        : viewCss = ['task-table', 'task-list', 'shared-list']; break

            case ViewType.PROJECT_TABLE                 :
            case ViewType.PROJECTS_PORTFOLIO            :
            case ViewType.CUSTOM_VIEW_TASKS_TABLE       :
            case ViewType.PORTFOLIO_SUMMARY             :
            case ViewType.PORTFOLIO_TABLE               : viewCss = ['task-table', 'shared-table']; break

            case ViewType.PROJECT_BOARD                 :
            case ViewType.CUSTOM_VIEW_BOARD             : viewCss = ['board-view', 'shared-board']; break

            case ViewType.PROJECT_CALENDAR              :
            case ViewType.CUSTOM_VIEW_CALENDAR          : viewCss = ['shared-calendar', 'events-calendar']; break

            case ViewType.PROJECT_GANTT                 :
            case ViewType.CUSTOM_VIEW_GANTT             : viewCss = ['gantt-chart', 'shared-gantt']; break

            case ViewType.PROJECT_WORKLOAD              :
            case ViewType.CUSTOM_VIEW_WORKLOAD          : viewCss = ['workload', 'shared-workload']; break

            case ViewType.PROJECT_ACTIVITY              :
            case ViewType.CUSTOM_VIEW_ACTIVITY          : viewCss = ['activity-stream', 'shared-activity-stream']; break

            case ViewType.CUSTOM_VIEW_WHATS_DONE        : viewCss = [{folder:'views/what-is-done', file:'what-is-done'}, 'shared-what-is-done']; break
            case ViewType.CUSTOM_VIEW_ACTION_REQUIRED   : viewCss = [{folder:'views/action-required', file:'action-required'}, 'shared-action-required']; break

            case ViewType.PROJECT_DOCS                  : viewCss = ['project-notes', 'shared-docs']; break

            case ViewType.PROJECT_VIEW_FORM             : viewCss = ['app-request-form']; break

            case ViewType.PROJECT_DASHBOARD             :
            case ViewType.CUSTOM_VIEW_DASHBOARD         : viewCss = ['dashboard', 'shared-dashboard']; break

            case ViewType.PROJECT_PAGE                  : viewCss = ['project-page', 'shared-page']; break
            case ViewType.PROJECT_TODOS                 : viewCss = ['project-todos']; break

        }

        _.map(css.concat(viewCss), (item: any)=>{
            if (typeof item === 'object')   res.push(this._loadCSS(item.folder,item.file));
            else                            res.push(this._loadCSS(item))
        })

        // APP
        switch (viewType) {
            case ViewType.PROJECT_LIST                  : res.push(this._loadAPP(projectListAppLoaderFunction)); break
            case ViewType.CUSTOM_VIEW_TASKS_LIST        : res.push(this._loadAPP(customViewListAppLoaderFunction)); break

            case ViewType.PROJECT_TABLE                 : res.push(this._loadAPP(projectTableAppLoaderFunction)); break
            case ViewType.PROJECTS_PORTFOLIO            : res.push(this._loadAPP(portfolioOldTableAppLoaderFunction)); break
            case ViewType.CUSTOM_VIEW_TASKS_TABLE       : res.push(this._loadAPP(customViewTableAppLoaderFunction)); break
            case ViewType.PORTFOLIO_SUMMARY             : res.push(this._loadAPP(portfolioSummaryAppLoaderFunction)); break
            case ViewType.PORTFOLIO_TABLE               : res.push(this._loadAPP(portfolioTableAppLoaderFunction)); break

            case ViewType.PROJECT_BOARD                 : res.push(this._loadAPP(projectBoardAppLoaderFunction)); break
            case ViewType.CUSTOM_VIEW_BOARD             : res.push(this._loadAPP(customViewBoardAppLoaderFunction)); break

            case ViewType.PROJECT_CALENDAR              : res.push(this._loadAPP(projectCalendarAppLoaderFunction)); break
            case ViewType.CUSTOM_VIEW_CALENDAR          : res.push(this._loadAPP(customViewCalendarAppLoaderFunction)); break

            case ViewType.PROJECT_GANTT                 : res.push(this._loadAPP(projectGanttAppLoaderFunction)); break
            case ViewType.CUSTOM_VIEW_GANTT             : res.push(this._loadAPP(customViewGanttAppLoaderFunction)); break

            case ViewType.PROJECT_WORKLOAD              : res.push(this._loadAPP(projectWorkloadAppLoaderFunction)); break
            case ViewType.CUSTOM_VIEW_WORKLOAD          : res.push(this._loadAPP(customViewWorkloadAppLoaderFunction)); break

            case ViewType.PROJECT_ACTIVITY              : res.push(this._loadAPP(projectActivityStreamAppLoaderFunction)); break
            case ViewType.CUSTOM_VIEW_ACTIVITY          : res.push(this._loadAPP(customViewActivityStreamAppLoaderFunction)); break

            case ViewType.CUSTOM_VIEW_WHATS_DONE        : res.push(this._loadAPP(customViewWhatIsDoneAppLoaderFunction)); break
            case ViewType.CUSTOM_VIEW_ACTION_REQUIRED   : res.push(this._loadAPP(customViewActionRequiredAppLoaderFunction)); break

            case ViewType.PROJECT_DOCS                  : res.push(this._loadAPP(projectDocsAppLoaderFunction)); break

            case ViewType.PROJECT_VIEW_FORM             : res.push(this._loadAPP(requestFormAppLoaderFunction)); break

            case ViewType.PROJECT_DASHBOARD             : res.push(this._loadAPP(projectDashboardAppLoaderFunction)); break
            case ViewType.CUSTOM_VIEW_DASHBOARD         : res.push(this._loadAPP(customDashboardAppLoaderFunction)); break

            case ViewType.PROJECT_PAGE                  : res.push(this._loadAPP(projectPageAppLoaderFunction)); break
            case ViewType.PROJECT_TODOS                 : res.push(this._loadAPP(projectTodosAppLoaderFunction)); break

            default                                     : res.push(this._loadAPP(unknownAppLoaderFunction)); break
        }

        // should CRM be displayed in Shared View?
        // if not then code below should be deleted
        switch (viewType) {
            case ViewType.PROJECT_LIST                :
            case ViewType.CUSTOM_VIEW_TASKS_LIST      :

            case ViewType.PROJECT_TABLE               :
            case ViewType.PROJECTS_PORTFOLIO          :
            case ViewType.CUSTOM_VIEW_TASKS_TABLE     :
            case ViewType.PORTFOLIO_SUMMARY           :
            case ViewType.PORTFOLIO_TABLE             :

            case ViewType.PROJECT_BOARD               :
            case ViewType.CUSTOM_VIEW_BOARD           :

            case ViewType.PROJECT_GANTT               :
            case ViewType.CUSTOM_VIEW_GANTT           :

            case ViewType.PROJECT_WORKLOAD            :
            case ViewType.CUSTOM_VIEW_WORKLOAD        :
                // currently nothing is returned for Shared View gd.api.Session.resetMissing({'crm': true}) request
                res.push(gd.session.crmAccounts)
                break

        }

        return res
    }

    renderNotFoundLoading() {
        when([this._loadAPP(notFoundAppLoaderFunction)]).then(()=>{
            this.resourceLoader.resolve(this.App, {})
        }).fail(()=>{
            this.renderErrorLoading()
        })
    }
}
